export const randomUsernames = [
  'Kartulisalat',
  'Hapu Kurk',
  'Rulaator',
  'Käbikuningas',
  'Põrsas Peeter',
  'Sussilont',
  'Õllevaat',
  'Kummikomm',
  'Peedipõld',
  'Karvane Käsi',
  'Kapsarull',
  'Lumehang',
  'Plätu',
  'Kõrvits',
  'Kukeseen',
  'Higihais',
  'Triibuline Sokk',
  'Mägisiga',
  'Grillkana',
  'Kapsapea',
  'Šašlõkivarras',
  'Kohuke',
  'Hakklihakaste',
  'Hallitusjuust',
  'Mängukaru',
  'Porgand',
  'Küüslauk',
  'Sibul',
  'Pannkoogimägi',
  'Lestakala',
  'Mõmmik',
  'Puravik',
  'Pastakas',
  'Põrandalamp',
  'Tolmuimeja',
  'Kartulikoor',
  'Leivapäts',
  'Põdrakanep',
  'Mopsikoer',
  'Kiviplaat',
  'Helbekene',
  'Pesumasin',
  'Saunaviht',
  'Maapähkel',
  'Juusturatas',
  'Särav Sokk',
  'Kiisu Miisu',
  'Vihmavari',
  'Mullivesi',
  'Tikutops',
  'Aiamaja',
  'Grillvorst',
  'Kanahautis',
  'Tindikass',
  'Kuuseke',
  'Harakas',
  'Kummik',
  'Suhkrukott',
  'Lehmapiim',
  'Vorstipirukas',
  'Seebivaht',
  'Põrandapesu',
  'Plekk-katus',
  'Lutikas',
  'Lumehelbeke',
  'Raadio Raju',
  'Küpsiseke',
  'Kummikaru',
  'Ketsid',
  'Prillipael',
  'Riisikott',
  'Piparkook',
  'Jõuluvana',
  'Kuum Kartul',
  'Ahjupraad',
  'Jänesepoeg',
  'Võileib',
  'Hapukoor',
  'Õunamoos',
  'Tõukeratas',
  'Juukselakk',
  'Kanafilee',
  'Ketsisuss',
  'Šokolaad',
  'Hernesupp',
  'Rämpstoit',
  'Viineripirukas',
  'Kirbukas',
  'Tantsukaru',
  'Ketsivunts',
  'Raudtee',
  'Piimapakk',
  'Kurk',
  'Kapsapirukas',
  'Õhupall',
  'Krõpsupakk',
  'Tiksumine',
  'Kanepitee',
  'Leivapurukas',
  'Kassi Käpp',
  'Majaahi',
  'Kartulikott',
  'Pastaroog',
  'Mängupult',
  'Ketsilont',
  'Koogike',
  'Mesi',
  'Viiner',
  'Udupealne',
  'Lambavill',
  'Kummimadrats',
  'Öökapp',
  'Rattakell',
  'Mürakarud',
  'Jonnipunn',
  'Karvane Plätu',
  'Värvipliiats',
  'Püksikumm',
  'Vurrud',
  'Lumeonu',
  'Kõrvaklapid',
  'Piimapudel',
  'Moosipurgike',
  'Hapukas',
  'Toidukile',
  'Riidepuu',
  'Märkmik',
  'Rukkilill',
  'Pusle',
  'Jääpurikas',
  'Lutikas',
  'Mürakaru',
  'Kukeseeneke',
  'Leivajupp',
  'Kartulipraad',
  'Karumõmm',
  'Vuntsivärk',
  'Kummikala',
  'Porilomp',
  'Sussike',
  'Ööloom',
  'Käbikäpp',
  'Vaarikamoos',
  'Õunapuu',
  'Kätekreem',
  'Jäätisekokteil',
  'Tursakala',
  'Hapupiim',
  'Kohvikruus',
  'Kaerahelbepuder',
  'Vihmapilv',
  'Rullnokk',
  'Kuivik',
  'Tähetolm',
  'Kartulisalat',
  'Hapu Kurk',
  'Rulaator',
  'Käbikuningas',
  'Põrsas Peeter',
  'Sussilont',
  'Õllevaat',
  'Kummikomm',
  'Peedipõld',
  'Karvane Käsi',
  'Kapsarull',
  'Lumehang',
  'Plätu',
  'Kõrvits',
  'Kukeseen',
  'Higihais',
  'Triibuline Sokk',
  'Mägisiga',
  'Grillkana',
  'Kapsapea',
  'Šašlõkivarras',
  'Kohuke',
  'Hakklihakaste',
  'Hallitusjuust',
  'Mängukaru',
  'Porgand',
  'Küüslauk',
  'Sibul',
  'Pannkoogimägi',
  'Lestakala',
  'Mõmmik',
  'Puravik',
  'Pastakas',
  'Põrandalamp',
  'Tolmuimeja',
  'Kartulikoor',
  'Leivapäts',
  'Põdrakanep',
  'Mopsikoer',
  'Kiviplaat',
  'Helbekene',
  'Pesumasin',
  'Saunaviht',
  'Maapähkel',
  'Juusturatas',
  'Särav Sokk',
  'Kiisu Miisu',
  'Vihmavari',
  'Mullivesi',
  'Tikutops',
  'Aiamaja',
  'Grillvorst',
  'Kanahautis',
  'Tindikass',
  'Kuuseke',
  'Harakas',
  'Kummik',
  'Suhkrukott',
  'Lehmapiim',
  'Vorstipirukas',
  'Seebivaht',
  'Põrandapesu',
  'Plekk-katus',
  'Lutikas',
  'Lumehelbeke',
  'Raadio Raju',
  'Küpsiseke',
  'Kummikaru',
  'Ketsid',
  'Prillipael',
  'Riisikott',
  'Piparkook',
  'Jõuluvana',
  'Kuum Kartul',
  'Ahjupraad',
  'Jänesepoeg',
  'Võileib',
  'Hapukoor',
  'Õunamoos',
  'Tõukeratas',
  'Juukselakk',
  'Kanafilee',
  'Ketsisuss',
  'Šokolaad',
  'Hernesupp',
  'Rämpstoit',
  'Viineripirukas',
  'Kirbukas',
  'Tantsukaru',
  'Ketsivunts',
  'Raudtee',
  'Piimapakk',
  'Kurk',
  'Kapsapirukas',
  'Õhupall',
  'Krõpsupakk',
  'Kanepitee',
  'Leivapurukas',
  'Kassi Käpp',
  'Majaahi',
  'Kartulikott',
  'Pastaroog',
  'Mängupult',
  'Ketsilont',
  'Koogike',
  'Mesi',
  'Viiner',
  'Udupealne',
  'Lambavill',
  'Kummimadrats',
  'Öökapp',
  'Rattakell',
  'Mürakarud',
  'Jonnipunn',
  'Karvane Plätu',
  'Värvipliiats',
  'Püksikumm',
  'Vurrud',
  'Lumeonu',
  'Kõrvaklapid',
  'Piimapudel',
  'Moosipurgike',
  'Hapukas',
  'Toidukile',
  'Riidepuu',
  'Märkmik',
  'Rukkilill',
  'Pusle',
  'Jääpurikas',
  'Lutikas',
  'Mürakaru',
  'Kukeseeneke',
  'Leivajupp',
  'Kartulipraad',
  'Karumõmm',
  'Vuntsivärk',
  'Kummikala',
  'Porilomp',
  'Sussike',
  'Ööloom',
  'Käbikäpp',
  'Vaarikamoos',
  'Õunapuu',
  'Kätekreem',
  'Jäätisekokteil',
  'Tursakala',
  'Hapupiim',
  'Kohvikruus',
  'Kaerahelbepuder',
  'Vihmapilv',
  'Rullnokk',
  'Kuivik',
  'Tähetolm',
  'Kiiksuga Kährik',
  'Õgardlik Orav',
  'Pupillikas Pistrik',
  'Õhetav Ahv',
  'Kiunuv Kana',
  'Nohisev Nugis',
  'Nätsutav Ninasarvik',
  'Kõõksuv Kukk',
  'Pahur Pääsuke',
  'Nurruv Noorhärra',
  'Krõbin Krabi',
  'Hüppav Hamster',
  'Pööritav Põrnikas',
  'Püüdlik Põrsas',
  'Torisev Tõug',
  'Nänniga Nandu',
  'Rõõmurull Rott',
  'Klähviv Koonukoer',
  'Mõmisev Mäger',
  'Kentsakas Kährikkoer',
  'Kärssav Kass',
  'Lärmav Lepatriinu',
  'Lõhnav Lõhe',
  'Totter Tigu',
  'Uimane Udukana',
  'Põrisev Pardipoeg',
  'Kukkav Kaelkirjak',
  'Seiklev Siil',
  'Uimav Ussike',
  'Pahisev Pistrik',
  'Köhiv Kährik',
  'Muigav Mutt',
  'Klähviv Koer',
  'Röövellik Rähn',
  'Näuguv Nirk',
  'Krigisev Krokodill',
  'Segane Seepia',
  'Jõhker Jõehobu',
  'Lontiv Lõvi',
  'Pööritav Põder',
  'Väntsutav Vaala',
  'Hirmunud Haug',
  'Võbelev Võsavillem',
  'Logisev Lutikas',
  'Unine Ussike',
  'Kõhnav Karu',
  'Kiunuv Kährik',
  'Totter Tõuk',
  'Kärisev Kassipoeg',
  'Kelmikas Kalkun',
  'Turbo-Tõnu',
  'Põleva Rehviga',
  'Õliplekk',
  'Kärssav Sidur',
  'Lada Legend',
  'Bensiinipäis',
  'Summuti-Sass',
  'Käigukang',
  'Tagasild',
  'Õhufilter',
  'Roolilukk',
  'Vilisev Veermex',
  'Diesel-Dennis',
  'Äärekivi-Ants',
  'Kiiruskaamera',
  'Parkimisandur',
  'Plekkvelg',
  'Käivituskaabel',
  'Rehvirõhk',
  'Klaasipuhastaja',
  'Pidurivedelik',
  'Veepump',
  'Mootoriõli',
  'Akuklemm',
  'Kärisev Käigukast',
  'Turbo-Siga',
  'Roolivõim',
  'Kuum Mootor',
  'Plärisev Plekk',
  'Kroomitud Kassett',
  'Tagaluuk',
  'Lõõtsaga Ladamees',
  'Ülevaatuseta',
  'Armatuur',
  'Vilkurid',
  'Kärts-Kärts',
  'Driftiv Datsun',
  'Kõksu-Karl',
  'Kärisev Karburaator',
  'Kapotialune',
  'Kiirtee-Kalle',
  'Tühikäik',
  'Puksilõvi',
  'Spidomeeter',
  'Tühjaks Jooksnud',
  'Kummivilin',
  'Üks Käik Puudu',
  'Puksiir',
  'Põder Kapotil',
  'Maastur-Madis',
  'Pannkoogi-Part',
  'Rehvilõhnane Rott',
  'Moosiplekk-Mutt',
  'Kapsapõder',
  'Turbo-Tigu',
  'Porgandipart',
  'Vihmavarju-Vombat',
  'Kartuli-Kass',
  'Spidomeetri-Siil',
  'Võileivahunt',
  'Plätu-Panda',
  'Kohvikruusi-Kõuts',
  'Maapähkli-Mõmmik',
  'Siduriga Siil',
  'Hapukurgi-Haug',
  'Rehvirõhu-Rästik',
  'Pastakakaru',
  'Juustuvunts',
  'Kummivilisev Kass',
  'Õliplekiline Orav',
  'Kiiver-Küülik',
  'Sidrunipart',
  'Õunamoosi-Uss',
  'Piimapaki-Põder',
  'Kõrvaklapi-Kassipoeg',
  'Kapsarulli-Krokodill',
  'Moosipudru-Mutt',
  'Turbo-Traktor',
  'Jõhvika-Jõehobu',
  'Rooliluku-Rästas',
  'Hambutu Hobune',
  'Kõhukoti-Känguru',
  'Leivapätsi-Lammas',
  'Siduri-Siil',
  'Karvane Kroom',
  'Õllevaadi-Orav',
  'Mürisev Marten',
  'Kellavärk-Kass',
  'Lontiv Lamborghini',
  'Hapupiima-Hunt',
  'Kiunuv Kia',
  'Bensiinibärs',
  'Pastapanni-Panda',
  'Grillkana-Gaz',
  'Kõlar-Kass',
  'Pannkoogipardikas',
  'Klõpsuv Krokodill',
  'Kaabakas Kaas',
  'Krõbisev Kaktus',
  'Turbo-Taldrik',
  'Turbo-Tõnu',
  'Põleva Rehviga',
  'Õliplekk',
  'Kärssav Sidur',
  'Lada Legend',
  'Bensiinipäis',
  'Summuti-Sass',
  'Käigukang',
  'Tagasild',
  'Õhufilter',
  'Roolilukk',
  'Vilisev Veermex',
  'Diesel-Dennis',
  'Äärekivi-Ants',
  'Kiiruskaamera',
  'Parkimisandur',
  'Plekkvelg',
  'Käivituskaabel',
  'Rehvirõhk',
  'Klaasipuhastaja',
  'Pidurivedelik',
  'Veepump',
  'Mootoriõli',
  'Akuklemm',
  'Kärisev Käigukast',
  'Turbo-Siga',
  'Roolivõim',
  'Kuum Mootor',
  'Plärisev Plekk',
  'Tagaluuk',
  'Ülevaatuseta',
  'Armatuur',
  'Vilkurid',
  'Driftiv Datsun',
  'Kärisev Karburaator',
  'Kapotialune',
  'Kiirtee-Kalle',
  'Tühikäik',
  'Puksiir',
  'Põder Kapotil',
  'Maastur-Madis',
  'Kõksu-Karl',
  'Rehvitoss',
  'Kolksuv Kolvid',
  'Kroomitud Kassett',
  'Puksiir-Peeter',
  'Lõhkev Lada',
  'Opel Omega',
  'Piduripedaal',
  'Driftiv Draakon',
  'Purjus Pingviin',
  'Närviline Näss',
  'Paks Panda',
  'Unine Uss',
  'Hüsteeriline Haug',
  'Tige Tibupoeg',
  'Kohmakas Krokodill',
  'Segane Siil',
  'Totu Tigu',
  'Põrunud Põder',
  'Kainestuv Kajakas',
  'Kärarikas Kährik',
  'Virisev Varblane',
  'Karvane Konn',
  'Möllav Mutt',
  'Totakas Tursk',
  'Joovastav Jänes',
  'Peata Part',
  'Kaval Kass',
  'Pirtsakas Pistrik',
  'Lamav Lammas',
  'Ümisenud Ükssarvik',
  'Röökur Rästik',
  'Mõmisev Mõmmik',
  'Kärsitu Kaelkirjak',
  'Köhiv Koer',
  'Lödistav Lõvi',
  'Muigav Morsa',
  'Kentsakas Kalkun',
  'Klounlik Kurg',
  'Ohkiv Orav',
  'Hüplev Hobune',
  'Lonkav Leopard',
  'Tossav Tuhkur',
  'Väänlev Vombat',
  'Kihutav Kilpkonn',
  'Nurruv Ninasarvik',
  'Kiikuv Kameeleon',
  'Õhetav Öökull',
  'Rändav Rähn',
  'Laisk Lutikas',
  'Kõhisev Kassipoeg',
  'Jõllitav Jõehobu',
  'Joonistav Jäär',
  'Tontlik Tursakala',
  'Uimane Ussike',
  'Krõbin Krabi',
  'Hüppav Hamster',
  'Püüdlik Põrsas',
  'Torisev Tõug',
  'Kartulisalat',
  'Hapu Kurk',
  'Vorstipirukas',
  'Plätu',
  'Kummikomm',
  'Porgand',
  'Sibul',
  'Kõrvits',
  'Kapsarull',
  'Grillkana',
  'Kohuke',
  'Rämpstoit',
  'Piparkook',
  'Juusturatas',
  'Tindikass',
  'Rukkilill',
  'Moosipurgike',
  'Jõuluvana',
  'Õhupall',
  'Mullivesi',
  'Krõpsupakk',
  'Leivapäts',
  'Pastaroog',
  'Riisikott',
  'Märkmik',
  'Pannkoogimägi',
  'Ahjupraad',
  'Piimapakk',
  'Õunamoos',
  'Hapukoor',
  'Tõukeratas',
  'Köhiv Kohuke',
  'Sussike',
  'Kartulikoor',
  'Toidukile',
  'Plekk-katus',
  'Tikutops',
  'Pesumasin',
  'Tolmuimeja',
  'Öökapp',
  'Kõrvaklapid',
  'Püksikumm',
  'Juukselakk',
  'Seebivaht',
  'Kanahautis',
  'Võileib',
  'Riidepuu',
  'Grillvorst',
  'Moosisai',
  'Kanapirukas',
];

// Fisher–Yates + immutability + kaitsecountile + valik unikaalsusele
export function getRandomUsernames(count = 7, unique = true): string[] {
  const safeCount = Math.max(0, Math.min(count, randomUsernames.length));

  // ära sega globaalset massiivi: tee koopia
  const pool = [...randomUsernames];

  // Kui soovid unikaalseid ja allikas sisaldab duplikaate,
  // siis võtame enne shufflimist unikaalse baasi:
  const base = unique ? Array.from(new Set(pool)) : pool;

  // Fisher–Yates shuffle
  for (let i = base.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [base[i], base[j]] = [base[j], base[i]];
  }

  return base.slice(0, safeCount);
}
